module.exports = __webpack_public_path__ + "b0fda91d3120ff49cb51c925dcb9ad9a.png";